export default __webpack_public_path__ + "static/media/Wedges-3s-200px.222ab313.svg";